/* eslint-disable no-shadow */
import {
    call, takeEvery
} from "redux-saga/effects";
import noop from "lodash.noop";

import {
    LOAD_REQUESTED,
    PROGRESS_REQUESTED,
    UPDATE_ASSIGNEES_REQUESTED,
    UPDATE_REQUESTED,
    defaultScopeId,
    failLoadWorkflowState,
    failProgressWorkflowState,
    failUpdateWorkflowState,
    failUpdateWorkflowStateAssignees,
    requestLoadWorkflowState,
    succeedProgressWorkflowState,
    succeedUpdateWorkflowState,
    succeedUpdateWorkflowStateAssignees,
    successLoadWorkflowState
} from "./project.duck";

import {
    loadWorkflowState,
    progressWorkflowState,
    updateWorkflowStateAssignees
} from "./project.api";

import { getId, injectApiWithContextFactory, injectBoundActionCreatorsFactory, withRefreshRequest } from "Utils/sagaUtils";

export const withBoundActions = injectBoundActionCreatorsFactory(
    {
        failLoadWorkflowState,
        failProgressWorkflowState,
        failUpdateWorkflowState,
        failUpdateWorkflowStateAssignees,
        requestLoadWorkflowState,
        succeedProgressWorkflowState,
        succeedUpdateWorkflowState,
        succeedUpdateWorkflowStateAssignees,
        successLoadWorkflowState
    },
    getId,
    defaultScopeId
);

export const withApiContext = injectApiWithContextFactory(
    { 
        loadWorkflowState,
        updateWorkflowStateAssignees,
        progressWorkflowState 
    }
);

export function* progressWorkflowStateSaga({
    data,
    actions: { succeedProgressWorkflowState, failProgressWorkflowState },
    api: { progressWorkflowState },
    resolve = noop,
    reject = noop,
}) {
    try {
        const result = yield progressWorkflowState(data);
        yield succeedProgressWorkflowState(result);
        yield call(resolve);
    } catch (e) {
        yield failProgressWorkflowState(e);
        yield call(reject, e);
    }
}

export function* updateWorkflowStateAssigneesSaga({
    data,
    actions: { succeedUpdateWorkflowStateAssignees, failUpdateWorkflowStateAssignees },
    api: { updateWorkflowStateAssignees },
    resolve = noop,
    reject = noop,
}) {
    try {
        const result = yield updateWorkflowStateAssignees(data);
        yield succeedUpdateWorkflowStateAssignees(result);
        yield call(resolve);
    } catch (e) {
        yield failUpdateWorkflowStateAssignees(e);
        yield call(reject, e);
    }
}

export function* updateWorkflowStateSaga({
    data,
    actions: { succeedWorkflowStateUpdate, failWorkflowStateUpdate },
    api: { updateWorkflowState },
    resolve = noop,
    reject = noop,
}) {
    try {
        const result = yield updateWorkflowState(data);
        yield succeedWorkflowStateUpdate(result);
        yield call(resolve);
    } catch (e) {
        yield failWorkflowStateUpdate(e);
        yield call(reject, e);
    }
}

export function* loadWorkflowStateSaga({
    data, actions: { successLoadWorkflowState, failLoadWorkflowState }, api: { loadWorkflowState }, resolve = noop, reject = noop 
}){
    try {
        const result = yield loadWorkflowState(data);
        yield successLoadWorkflowState(result);
        yield call(resolve);
    } catch (e){
        yield failLoadWorkflowState(e);
        yield call(reject, e);
    }
}

export default () => function* rootSaga() {
    yield takeEvery(UPDATE_REQUESTED, withBoundActions(withApiContext(updateWorkflowStateSaga)));
    yield takeEvery(PROGRESS_REQUESTED, withBoundActions(withApiContext(progressWorkflowStateSaga)));
    yield takeEvery(UPDATE_ASSIGNEES_REQUESTED, withBoundActions(withApiContext(updateWorkflowStateAssigneesSaga)));
    yield takeEvery(LOAD_REQUESTED, withRefreshRequest(withBoundActions(withApiContext(loadWorkflowStateSaga))));
};
